import axios from "axios";
import { ACCESS_TOKEN } from "constants/auth";

export const axiosBase = axios.create({
  baseURL: process.env.REACT_APP_API_URL,

  headers: {
    "Content-Type": "application/json",
    "Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,

    ...(localStorage.getItem(ACCESS_TOKEN)
      ? { Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN) }
      : {}),
  },
});
